import { Converter } from '../types/converter';

export const viscosityKinematicConverter: Converter = {
  id: 'viscosityKinematic',
  name: 'Kinematic Viscosity Converter',
  icon: 'Droplets',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit
    { name: 'Square meter/second', symbol: 'm²/s', factor: 1 },
    { name: 'Square meter/hour', symbol: 'm²/h', factor: 0.000277778 },
    { name: 'Square centimeter/second', symbol: 'cm²/s', factor: 0.0001 },
    { name: 'Square millimeter/second', symbol: 'mm²/s', factor: 1e-6 },
    { name: 'Square foot/second', symbol: 'ft²/s', factor: 0.092903 },
    { name: 'Square foot/hour', symbol: 'ft²/h', factor: 2.58064e-5 },
    { name: 'Square inch/second', symbol: 'in²/s', factor: 0.00064516 },
    
    // Stokes and derivatives
    { name: 'Stokes', symbol: 'St', factor: 0.0001 },
    { name: 'Exastokes', symbol: 'ESt', factor: 1e14 },
    { name: 'Petastokes', symbol: 'PSt', factor: 1e11 },
    { name: 'Terastokes', symbol: 'TSt', factor: 1e8 },
    { name: 'Gigastokes', symbol: 'GSt', factor: 1e5 },
    { name: 'Megastokes', symbol: 'MSt', factor: 100 },
    { name: 'Kilostokes', symbol: 'kSt', factor: 0.1 },
    { name: 'Hectostokes', symbol: 'hSt', factor: 0.01 },
    { name: 'Dekastokes', symbol: 'daSt', factor: 0.001 },
    { name: 'Decistokes', symbol: 'dSt', factor: 0.00001 },
    { name: 'Centistokes', symbol: 'cSt', factor: 1e-6 },
    { name: 'Millistokes', symbol: 'mSt', factor: 1e-7 },
    { name: 'Microstokes', symbol: 'µSt', factor: 1e-10 },
    { name: 'Nanostokes', symbol: 'nSt', factor: 1e-13 },
    { name: 'Picostokes', symbol: 'pSt', factor: 1e-16 },
    { name: 'Femtostokes', symbol: 'fSt', factor: 1e-19 },
    { name: 'Attostokes', symbol: 'aSt', factor: 1e-22 }
  ]
};
